import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Expand Your Business Reach with Results-Driven Paid Advertising Solutions. Our expert team specializes in Google Ads, social network advertising, and display advertising, delivering targeted campaigns that increase brand visibility, drive traffic, and generate valuable leads.",
    servicePointsLoop: [
      "Our paid advertising solutions are designed to deliver measurable results, helping businesses achieve their marketing goals and drive growth.",
      "Targeted Audience Reach: With paid advertising, businesses can precisely target their desired audience, reaching specific demographics and maximizing the effectiveness of their marketing efforts.",
      "Increased Brand Visibility: Investing in sponsored advertising enhances brand visibility and awareness, making it easier to capture the attention of potential clients and stand out in a competitive market.",
      "Customized Campaigns: Our experienced professionals understand the paid advertising landscape, offering tailored campaigns across various platforms like Google Ads and social networks, optimizing conversions and driving desired outcomes.",
    ],
    serviceDiv: [
      {
        heading: "Results-Driven Approach",
        description: "Data-driven strategies for optimal campaign performance.",
      },
      {
        heading: "Targeted Audience Reach",
        description:
          "Precise audience targeting based on demographics, interests, and behavior.",
      },
      {
        heading: "Increased Brand Visibility",
        description: "Strategic placement of ads to increase brand awareness.",
      },
      {
        heading: "Customized Campaigns",
        description:
          "Tailored advertising strategies based on business goals and target audience.",
      },
    ],
  };
  let workWithUs =
    "Partner with us to unlock the full potential of your paid advertising campaigns. Our expertise and tailored approach will help you achieve targeted audience reach, increased brand visibility, and measurable results for your business.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Paid Advertisement" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
